module.exports = "\n<div class=\"datafield\">\n  <div>\n    <p>{{name}}</p>\n  </div>\n  <div>\n    <p>{{value}}</p>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/common/field.html
 ** module id = 249
 ** module chunks = 1
 **/